module.exports = __webpack_public_path__ + "media/images/500-startups-d384bee96442e28258f8f08a6400ced5.png";